import type { ApprovedAdminExit } from "./adminDepartureRuntime";
import {
  adminDepartureCoordinator,
  captureApprovedAdminExit,
  getAdminDepartureHistory,
  runApprovedAdminExit,
} from "./adminDepartureRuntime";
import { isAdminSignOutLocked } from "./adminSignOutLock";

export type BroadcastExit = () => void | Promise<void>;
interface BroadcastLeaveGuard {
  onPop: (event: PopStateEvent) => void;
  requestExit: (exit: BroadcastExit) => void;
}
/** Compatibility entry point for callers that install before BrowserRouter. */
export function installBroadcastHistoryGuard(): void {
  getAdminDepartureHistory().install();
}

export function registerBroadcastLeaveGuard(
  guard: BroadcastLeaveGuard,
): () => void {
  const unregister = adminDepartureCoordinator.register({
    isAffected: () => true,
    read: () => ({ active: true, busy: false, revision: "legacy" }),
    requestConsent: (consent) => guard.requestExit(() => consent.approve()),
  });
  return unregister;
}

/** Defer voluntary navigation/session clearing until the dirty editor allows it. */
export function requestBroadcastExit(
  exit: (approved: ApprovedAdminExit) => void | Promise<void>,
): void | Promise<void> {
  if (isAdminSignOutLocked()) return;
  let result: void | Promise<void> = undefined;
  adminDepartureCoordinator.request({ kind: "exit" }, () => {
    const approved = captureApprovedAdminExit();
    result = runApprovedAdminExit(() => exit(approved));
  });
  return result;
}
